import axios from 'axios';
import { toApiBlockFormat } from 'sharedParts';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import changeRedirectUrlSubmissionError from './submissionErrors/changeRedirectUrlSubmissionError';

const updateBlockBulk = (collectionPath, entityId, blockList) =>
  axios
    .patch(getUrl.apiV2(`${collectionPath}/${entityId}/items/bulk`), {
      data: blockList.map(block => ({
        id: block.id,
        ...toApiBlockFormat(block),
      })),
    })
    .catch(
      generateApiError({
        submissionErrorMap: changeRedirectUrlSubmissionError,
      }),
    );

export default updateBlockBulk;
